"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var HangulSyllable_1 = __importDefault(require("./HangulSyllable"));
var JamoBlock_1 = require("./JamoBlock");
var isJamo_1 = __importDefault(require("./utlils/isJamo"));
/**
 * 음절을 조합하고 완성하는 IME
 */
var HangulIme = /** @class */ (function () {
    function HangulIme() {
        this._latestCompletedSyllable = "";
        this._composingSyllable = "";
        this._imeStep = "empty";
        this._syllable = new HangulSyllable_1.default();
    }
    Object.defineProperty(HangulIme.prototype, "latestCompletedSyllable", {
        get: function () {
            return this._latestCompletedSyllable;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HangulIme.prototype, "composingSyllable", {
        get: function () {
            return this._composingSyllable;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HangulIme.prototype, "imeStep", {
        get: function () {
            return this._imeStep;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 한글 자모를 입력한다.
     * @param inputKey 한글 자모 키 값
     * @returns {IInsertCallback}
     */
    HangulIme.prototype.insert = function (inputKey) {
        if (!isJamo_1.default(inputKey)) {
            this._imeStep = "completed";
            return this;
        }
        var isPossibleInput = this._syllable.tryInput(inputKey);
        if (isPossibleInput)
            return this.composing();
        this.complete(inputKey);
        return this;
    };
    /**
     * 한글 음절에 백스페이스를 물리다
     * @returns {IInsertCallback}
     */
    HangulIme.prototype.backspace = function () {
        var isPossibleBackspace = this._syllable.tryBackspace();
        if (isPossibleBackspace && this._syllable.composingSyllable) {
            this._imeStep = "composing";
        }
        else {
            this._imeStep = "empty";
        }
        this._composingSyllable = this._syllable.composingSyllable;
        return this;
    };
    /** 글자 조합이 완성된 경우 callback을 호출한다. */
    HangulIme.prototype.onComplete = function (callback) {
        if (this._imeStep === "completed")
            callback(this.latestCompletedSyllable, this.composingSyllable);
        return this;
    };
    /** 조합중인 글자가 빈 경우 callback을 호출한다. */
    HangulIme.prototype.onEmpty = function (callback) {
        if (this._imeStep === "empty")
            callback();
        return this;
    };
    /** 글자를 조합 중인 경우 callback을 호출한다. */
    HangulIme.prototype.onCompose = function (callback) {
        if (this._imeStep === "composing")
            callback(this._composingSyllable);
    };
    HangulIme.prototype.clear = function () {
        this._syllable.clear();
        this._composingSyllable = this._syllable.composingSyllable;
        this._imeStep = "empty";
    };
    HangulIme.prototype.complete = function (inputKey) {
        this._imeStep = "completed";
        var inputKeyJamo = new JamoBlock_1.JamoBlock(inputKey);
        var newSyllable = new HangulSyllable_1.default();
        var prevSyllable = this._syllable;
        this._syllable = newSyllable;
        if (inputKeyJamo.isVowel() && prevSyllable.finalConsonat) {
            decomposeSyllable(inputKey, prevSyllable, newSyllable);
        }
        else {
            newSyllable.tryInput(inputKey);
        }
        this._latestCompletedSyllable = prevSyllable.composingSyllable;
        this._composingSyllable = newSyllable.composingSyllable;
    };
    HangulIme.prototype.composing = function () {
        this._imeStep = "composing";
        this._composingSyllable = this._syllable.composingSyllable;
        return this;
    };
    return HangulIme;
}());
exports.default = HangulIme;
function decomposeSyllable(inputKey, prevSyllable, newSyllable) {
    var consonatsBlock = new JamoBlock_1.JamoBlock(prevSyllable.finalConsonat);
    if (consonatsBlock.isComposedFinalConsonats()) {
        var consonats = consonatsBlock.decompose();
        newSyllable.tryInput(consonats[1]);
        newSyllable.tryInput(inputKey);
    }
    else {
        newSyllable.tryInput(consonatsBlock.character);
        newSyllable.tryInput(inputKey);
    }
    prevSyllable.tryBackspace();
}
